
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organization_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"remove_optix_branding"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"remove_optix_branding_for_admins"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enable_app_help_center"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enable_contact_admin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enable_optix_support_widget"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enable_whats_new"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enable_bento"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enable_ai_automations_assistant"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enable_ai_internal_tester"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationUpdateFeatures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organization_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organization_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"remove_optix_branding"},"value":{"kind":"Variable","name":{"kind":"Name","value":"remove_optix_branding"}}},{"kind":"Argument","name":{"kind":"Name","value":"remove_optix_branding_for_admins"},"value":{"kind":"Variable","name":{"kind":"Name","value":"remove_optix_branding_for_admins"}}},{"kind":"Argument","name":{"kind":"Name","value":"enable_app_help_center"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enable_app_help_center"}}},{"kind":"Argument","name":{"kind":"Name","value":"enable_contact_admin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enable_contact_admin"}}},{"kind":"Argument","name":{"kind":"Name","value":"enable_optix_support_widget"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enable_optix_support_widget"}}},{"kind":"Argument","name":{"kind":"Name","value":"enable_whats_new"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enable_whats_new"}}},{"kind":"Argument","name":{"kind":"Name","value":"enable_bento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enable_bento"}}},{"kind":"Argument","name":{"kind":"Name","value":"enable_ai_automations_assistant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enable_ai_automations_assistant"}}},{"kind":"Argument","name":{"kind":"Name","value":"enable_ai_internal_tester"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enable_ai_internal_tester"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"features"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"remove_optix_branding"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"remove_optix_branding_for_admins"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enable_app_help_center"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enable_contact_admin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enable_optix_support_widget"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enable_whats_new"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enable_bento"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enable_ai_automations_assistant"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enable_ai_internal_tester"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1215}};
    doc.loc.source = {"body":"mutation(\n  $organization_id: ID!\n  $remove_optix_branding: Boolean\n  $remove_optix_branding_for_admins: Boolean\n  $enable_app_help_center: Boolean\n  $enable_contact_admin: Boolean\n  $enable_optix_support_widget: Boolean\n  $enable_whats_new: Boolean\n  $enable_bento: Boolean\n  $enable_ai_automations_assistant: Boolean\n  $enable_ai_internal_tester: Boolean\n) {\n  organizationUpdateFeatures(\n    organization_id: $organization_id\n    remove_optix_branding: $remove_optix_branding\n    remove_optix_branding_for_admins: $remove_optix_branding_for_admins\n    enable_app_help_center: $enable_app_help_center\n    enable_contact_admin: $enable_contact_admin\n    enable_optix_support_widget: $enable_optix_support_widget\n    enable_whats_new: $enable_whats_new\n    enable_bento: $enable_bento\n    enable_ai_automations_assistant: $enable_ai_automations_assistant\n    enable_ai_internal_tester: $enable_ai_internal_tester\n  ) {\n    features {\n      remove_optix_branding\n      remove_optix_branding_for_admins\n      enable_app_help_center\n      enable_contact_admin\n      enable_optix_support_widget\n      enable_whats_new\n      enable_bento\n      enable_ai_automations_assistant\n      enable_ai_internal_tester\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
